module.exports = __webpack_public_path__ + "img/icon-8.6db8e02a.png";